import { useConfetti } from "@/providers/confettiProvider";
import { calculateProgress } from "@/components/dashboard/progressCalculator";
import { extractDateFromDate } from "@/utilities/dateFormatter";
import { isRoutineActiveToday } from "@/hooks/routines/useRoutine.utils";
import type { Routine } from "instantdb/types";
import { useMobile } from "@/providers/mobileProvider";
import { useSetAtom } from "jotai";
import { androidReviewDialog } from "@/state/dialogs";
import { useUpdateUser } from "./auth-hooks";
import { useUser } from "./useUser";

export function useConfettiProgress() {
  const { fireConfetti } = useConfetti();
  const { isIOS, isAndroid } = useMobile();
  const setAndroidReviewDialogOpen = useSetAtom(androidReviewDialog);
  const { mutateAsync } = useUpdateUser();
  const { user } = useUser();

  const checkAndFireConfetti = (routines: Routine[]) => {
    // Only routines that are accepted
    const acceptedRoutines = routines.filter(
      (routine) => routine.aiAccepted || !routine.aiGenerated,
    );

    // Only routines that are active for the current day
    const activeRoutines = acceptedRoutines.filter(isRoutineActiveToday);

    const today = extractDateFromDate(new Date());
    const { percentage, totalSteps } = calculateProgress(today, activeRoutines);

    if (percentage === 100 && totalSteps > 0 && activeRoutines.length > 0) {
      fireConfetti({});

      // Ask for review on iOS
      if (isIOS) {
        window.nativeBridge?.requestReview();
      }

      if (isAndroid && !user?.hasBeenAskedForReview) {
        setAndroidReviewDialogOpen(true);
        mutateAsync({
          hasBeenAskedForReview: true,
        });
      }
    }
  };

  return {
    checkAndFireConfetti,
  };
}
